var map = {
	"./bg@2x.png": "df8a",
	"./circle@2x.png": "eafc",
	"./icon_down@2x.png": "5aac",
	"./icon_up@2x.png": "d457",
	"./img_sj@2x.png": "1af9",
	"./img_wsj@2x.png": "3692",
	"./img_ycs@2x.png": "165e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1670";